import { CheckIcon } from "../../assets";
import { COLORS } from "../../constants";
import styles from "./styles.module.scss";

type StatusBadgeProps = {
  status: "logged" | "planned";
  isSkipped?: boolean;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, isSkipped }) => {
  return (
    <div
      style={{
        backgroundColor: isSkipped
          ? COLORS.darkGray
          : status === "logged"
          ? "rgba(54, 217, 14, 1)"
          : "rgba(245, 247, 250, 1)",
      }}
      className={styles.wrapper}
    >
      {status === "logged" ? (
        <CheckIcon style={{ width: 10, height: 10 }} />
      ) : null}
      <span
        style={{
          color: isSkipped
            ? COLORS.white
            : status === "logged"
            ? "white"
            : "rgba(106, 115, 127, 1)",
        }}
      >
        {status === "logged" ? "LOGGED" : "PLANNED"}
      </span>
    </div>
  );
};

export default StatusBadge;
